module.exports = __webpack_public_path__ + "application/templates/default/default.template.html";